import '../../style/default.less';
import './index.less'; // style dependencies

import '../../button/style';